"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistStrategy = void 0;
var lodash_1 = require("lodash");
var valtio_1 = require("valtio");
var utils_1 = require("valtio/utils");
// "multi" only works for object type.
var PersistStrategy;
(function (PersistStrategy) {
    PersistStrategy["SingleFile"] = "SingleFile";
    PersistStrategy["MultiFile"] = "MultiFile";
})(PersistStrategy = exports.PersistStrategy || (exports.PersistStrategy = {}));
function proxyWithPersist(inputs) {
    var _this = this;
    var onBeforeWrite = inputs.onBeforeWrite || (function (write) { return write(); });
    var proxyObject = (0, valtio_1.proxy)(__assign(__assign({}, inputs.initialState), { _persist: {
            version: inputs.version,
            status: 'loading',
            loading: true,
            loaded: false,
            error: null,
        } }));
    (function () { return __awaiter(_this, void 0, void 0, function () {
        var storage, pendingWrites, bulkWrite, onBeforeBulkWrite, allKeys, _a, metaFilePath, metaPersistedString, metaPersistedData, currentVersion, migration;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, inputs.getStorage()];
                case 1:
                    storage = _b.sent();
                    pendingWrites = {};
                    bulkWrite = function () {
                        return Promise.all(Object.entries(pendingWrites).map(function (_a) {
                            var filePath = _a[0], value = _a[1];
                            // TODO: if removeItem/setItem fails, and pendingWrites doesn't include
                            // filePath, then restore this. if it includes it on error, it means
                            // another write/delete got queued up, and that takes precedence.
                            delete pendingWrites[filePath];
                            var write;
                            if (value === null) {
                                // delete it
                                write = function () {
                                    return storage.removeItem(filePath);
                                };
                            }
                            else {
                                write = function () {
                                    return storage.setItem(filePath, JSON.stringify(value));
                                };
                            }
                            return onBeforeWrite(write, filePath);
                        }));
                    };
                    onBeforeBulkWrite = inputs.onBeforeBulkWrite || (function (bulkWriteRef) { return bulkWriteRef(); });
                    if (!(inputs.persistStrategies === PersistStrategy.MultiFile ||
                        Object.values(inputs.persistStrategies).includes(PersistStrategy.MultiFile))) return [3 /*break*/, 3];
                    return [4 /*yield*/, storage.getAllKeys()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = [];
                    _b.label = 4;
                case 4:
                    allKeys = _a;
                    return [4 /*yield*/, Promise.all(Object.entries(typeof inputs.persistStrategies === 'string' ? { '': inputs.persistStrategies } : inputs.persistStrategies).map(function loadPath(_a) {
                            var path = _a[0], strategy = _a[1];
                            return __awaiter(this, void 0, void 0, function () {
                                var isPersistingMainObject, filePath, pathParts, pathStart, pathKey, proxySubObject, persistedString, persistedValue, target, persistPath_1, prevValue_1, persistLeaf_1;
                                var _this = this;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            isPersistingMainObject = path === '';
                                            filePath = inputs.name + '-' + path;
                                            pathParts = (0, lodash_1.toPath)(path);
                                            pathStart = pathParts.slice(0, -1).join('');
                                            pathKey = pathParts.slice(-1)[0];
                                            proxySubObject = isPersistingMainObject || pathStart === '' ? proxyObject : (0, lodash_1.get)(proxyObject, pathStart);
                                            if (!(strategy === PersistStrategy.SingleFile)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, storage.getItem(filePath)];
                                        case 1:
                                            persistedString = _b.sent();
                                            if (persistedString === null) {
                                                // file does not exist
                                            }
                                            else {
                                                persistedValue = JSON.parse(persistedString);
                                                if (isPersistingMainObject) {
                                                    Object.assign(proxyObject, persistedValue);
                                                }
                                                else {
                                                    target = (0, lodash_1.get)(proxyObject, path);
                                                    if ((0, lodash_1.isPlainObject)(target) && (0, lodash_1.isPlainObject)(persistedValue)) {
                                                        Object.assign(target, persistedValue);
                                                    }
                                                    else {
                                                        (0, lodash_1.set)(proxyObject, path, persistedValue);
                                                    }
                                                }
                                            }
                                            persistPath_1 = function (value) {
                                                var target = value && typeof value === 'object' ? (0, valtio_1.snapshot)(value) : value;
                                                pendingWrites[filePath] = target;
                                                if (isPersistingMainObject) {
                                                    pendingWrites[filePath] = (0, lodash_1.omit)(target, '_persist');
                                                }
                                                onBeforeBulkWrite(bulkWrite);
                                            };
                                            if (isPersistingMainObject) {
                                                (0, valtio_1.subscribe)(proxyObject, function (ops) {
                                                    // if (!proxyObject._persist.loaded) {
                                                    //   return;
                                                    // }
                                                    if (ops.every(function (op) { return op[1][0] === '_persist'; })) {
                                                        return;
                                                    }
                                                    persistPath_1(proxyObject);
                                                });
                                            }
                                            else {
                                                (0, utils_1.subscribeKey)(proxySubObject, pathKey, persistPath_1);
                                            }
                                            return [3 /*break*/, 5];
                                        case 2:
                                            if (!(strategy === PersistStrategy.MultiFile)) return [3 /*break*/, 4];
                                            return [4 /*yield*/, Promise.all(allKeys
                                                    .filter(function (persistedFilePath) {
                                                    return persistedFilePath.startsWith(inputs.name + '-');
                                                })
                                                    .filter(function (persistedFilePath) {
                                                    if (isPersistingMainObject) {
                                                        return persistedFilePath.split('-')[0] === inputs.name;
                                                    }
                                                    else {
                                                        return (0, lodash_1.toPath)(persistedFilePath).slice(0, -1).join('.') === filePath;
                                                    }
                                                })
                                                    .map(function (persistedFilePath) { return __awaiter(_this, void 0, void 0, function () {
                                                    var persistedString, persistedValue, targetPath, target;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, storage.getItem(persistedFilePath)];
                                                            case 1:
                                                                persistedString = _a.sent();
                                                                if (persistedString === null) {
                                                                    throw new Error("Could not find file for leafPath found of \"" + persistedFilePath + "\", this should not be possible as this was returned by storage.getAllKeys");
                                                                }
                                                                persistedValue = JSON.parse(persistedString);
                                                                targetPath = persistedFilePath.substring(inputs.name.length + '-'.length);
                                                                target = (0, lodash_1.get)(proxyObject, targetPath);
                                                                if ((0, lodash_1.isPlainObject)(target) && (0, lodash_1.isPlainObject)(persistedValue)) {
                                                                    Object.assign(target, persistedValue);
                                                                }
                                                                else {
                                                                    (0, lodash_1.set)(proxyObject, targetPath, persistedValue);
                                                                }
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }))];
                                        case 3:
                                            _b.sent();
                                            prevValue_1 = isPersistingMainObject
                                                ? (0, lodash_1.omit)((0, valtio_1.snapshot)(proxyObject), '_persist')
                                                : (0, valtio_1.snapshot)(proxySubObject[pathKey]);
                                            persistLeaf_1 = function (valueProxy) {
                                                var value = (0, valtio_1.snapshot)(valueProxy);
                                                if (isPersistingMainObject) {
                                                    value = (0, lodash_1.omit)(value, '_persist');
                                                }
                                                // figured out which subkeys were added, removed, changed
                                                var keys = new Set(Object.keys(value));
                                                var prevKeys = new Set(Object.keys(prevValue_1));
                                                var possiblyUpdatedKeys = new Set(Object.keys(value));
                                                var addedKeys = [];
                                                keys.forEach(function (key) {
                                                    if (!prevKeys.has(key)) {
                                                        addedKeys.push(key);
                                                        possiblyUpdatedKeys.delete(key);
                                                    }
                                                });
                                                var removedKeys = [];
                                                prevKeys.forEach(function (prevKey) {
                                                    if (!keys.has(prevKey)) {
                                                        removedKeys.push(prevKey);
                                                        possiblyUpdatedKeys.delete(prevKey);
                                                    }
                                                });
                                                var updatedKeys = [];
                                                possiblyUpdatedKeys.forEach(function (possiblyUpdatedKey) {
                                                    var prevKeyValue = prevValue_1[possiblyUpdatedKey];
                                                    var keyValue = value[possiblyUpdatedKey];
                                                    if (prevKeyValue !== keyValue) {
                                                        updatedKeys.push(possiblyUpdatedKey);
                                                    }
                                                });
                                                prevValue_1 = isPersistingMainObject
                                                    ? (0, lodash_1.omit)((0, valtio_1.snapshot)(proxyObject), '_persist')
                                                    : (0, valtio_1.snapshot)(proxySubObject[pathKey]);
                                                if (addedKeys.length || removedKeys.length || updatedKeys.length) {
                                                    removedKeys.forEach(function (key) {
                                                        pendingWrites[filePath + (isPersistingMainObject ? '' : '.') + key] = null;
                                                    });
                                                    __spreadArray(__spreadArray([], addedKeys, true), updatedKeys, true).forEach(function (key) {
                                                        pendingWrites[filePath + (isPersistingMainObject ? '' : '.') + key] = value[key];
                                                    });
                                                    onBeforeBulkWrite(bulkWrite);
                                                }
                                            };
                                            if (isPersistingMainObject) {
                                                (0, valtio_1.subscribe)(proxyObject, function (ops) {
                                                    // if (!proxyObject._persist.loaded) {
                                                    //   return;
                                                    // }
                                                    if (ops.every(function (op) { return op[1][0] === '_persist'; })) {
                                                        return;
                                                    }
                                                    persistLeaf_1(proxyObject);
                                                });
                                            }
                                            else {
                                                (0, utils_1.subscribeKey)(proxySubObject, pathKey, persistLeaf_1);
                                            }
                                            return [3 /*break*/, 5];
                                        case 4: throw new Error("Unknown persist strategy of \"" + strategy + "\" for path \"" + filePath + "\".");
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            });
                        }))];
                case 5:
                    _b.sent();
                    metaFilePath = inputs.name + '-_persist';
                    return [4 /*yield*/, storage.getItem(metaFilePath)];
                case 6:
                    metaPersistedString = _b.sent();
                    metaPersistedData = metaPersistedString ? JSON.parse(metaPersistedString) : null;
                    if (!metaPersistedData) return [3 /*break*/, 10];
                    if (!(metaPersistedData.version < inputs.version)) return [3 /*break*/, 10];
                    currentVersion = metaPersistedData.version + 1;
                    _b.label = 7;
                case 7:
                    if (!(currentVersion <= inputs.version)) return [3 /*break*/, 10];
                    migration = inputs.migrations[currentVersion];
                    if (!migration) return [3 /*break*/, 9];
                    return [4 /*yield*/, migration()];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    currentVersion++;
                    return [3 /*break*/, 7];
                case 10:
                    if (!((metaPersistedData === null || metaPersistedData === void 0 ? void 0 : metaPersistedData.version) !== inputs.version)) return [3 /*break*/, 12];
                    return [4 /*yield*/, storage.setItem(metaFilePath, JSON.stringify({
                            version: inputs.version,
                        }))];
                case 11:
                    _b.sent();
                    _b.label = 12;
                case 12:
                    Object.assign(proxyObject._persist, {
                        loaded: true,
                        loading: false,
                        status: 'loaded',
                    });
                    return [2 /*return*/];
            }
        });
    }); })();
    return proxyObject;
}
exports.default = proxyWithPersist;
